// Avatar — shows a user's TMCHub profile picture when available, otherwise a
// coloured initials fallback. Used for message senders, the @mention list, etc.

import { useState } from "react";

const VARIANTS = ["a", "b", "c", "d", "e"];
export const variantFor = (id) => VARIANTS[Math.abs(Number(id) || 0) % VARIANTS.length];
// First name + surname initials — first letter of the first word + first letter of the LAST word
// (e.g. "Jennifer Smith" → JS, "Mary Jane Watson" → MW). A single-word name → just its first letter.
export const initials = (name) => {
  const w = (name || "").trim().split(/\s+/).filter(Boolean);
  if (w.length === 0) return "?";
  const s = w.length > 1 ? (w[0][0] + w[w.length - 1][0]) : w[0][0];
  return s.toUpperCase();
};

export default function Avatar({ userId, name, url, size = "", className = "" }) {
  // Track the URL that failed to load so a broken/missing profile pic falls back to initials
  // rather than showing a broken-image icon. Keyed by URL so a later valid URL still tries.
  const [failedUrl, setFailedUrl] = useState("");
  const sizeCls = size ? `avatar--${size}` : "";
  const src = typeof url === "string" ? url.trim() : "";
  const showImg = src && src !== failedUrl; // blank/whitespace URL → initials; broken load → initials
  return (
    <span className={`avatar ${sizeCls} avatar--${variantFor(userId)} ${className}`} aria-hidden>
      {showImg
        ? <img src={src} alt="" className="avatar__img" loading="lazy" onError={() => setFailedUrl(src)} />
        : initials(name)}
    </span>
  );
}
